// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Thông báo chuyển hướng ứng dụng khách",
  "1d484fee4a": "Phòng Tài chính, Phòng Kinh doanh, Quản lý Dự án, Dữ liệu Kinh doanh, Phòng Sản phẩm, Phòng Vận hành, Quản lý R&D, Kế hoạch Phiên bản, Phòng Chăm sóc Khách hàng, Phòng Hành chính, Phòng Mua hàng, Quản lý Hậu mãi",
  "a2c88dfb79": "Tạo nhóm đầu tiên của bạn",
  "3cfdcc6086": "Phòng Tài chính, Phòng Kinh doanh, Quản lý Dự án/305, Hành chính Nhân sự/306, Phòng Vận hành, Quản lý R&D, Kế hoạch Phiên bản, Quản lý Chăm sóc Khách hàng/403, Phòng Mua hàng, Quản lý Hậu mãi",
  "ac45ec2c05": "Xác minh đăng nhập tài khoản không thành công",
  "9aef9b8ccd": "Tài khoản đang đăng nhập gặp lỗi, vui lòng đăng nhập lại và thử lại",
  "728dd00f22": "Số điện thoại này xác minh gặp lỗi, vui lòng thử đăng nhập bằng mã xác minh SMS",
  "30dbecd916": "Thông tin bạn nhập chứa từ nhạy cảm, vui lòng sửa đổi và thử lại",
  "12ed508d8a": "Bạn thao tác quá thường xuyên, vui lòng thử lại sau",
  "952d4a7595": "Trạng thái đăng nhập của tài khoản hiện tại gặp lỗi, vui lòng đăng nhập lại và thử lại",
  "e64bfdeaa4": "Xác minh đăng nhập không thành công, vui lòng lấy lại mã xác minh SMS",
  "79008a65f1": "Số điện thoại này đã tham gia nhiều doanh nghiệp, vui lòng đăng nhập vào doanh nghiệp hoặc đổi số điện thoại khác",
  "bf242eff42": "Tên doanh nghiệp đã tồn tại",
  "4f0cdb8374": "Vui lòng nhập số điện thoại đầy đủ. Nếu bạn đang sử dụng số điện thoại nước ngoài, vui lòng đổi sang số điện thoại trong nước (86+)",
  "46e79ffeff": "Tạo doanh nghiệp gặp lỗi, vui lòng liên hệ bộ phận chăm sóc khách hàng chính thức để được giải quyết",
  "f3e18f0341": "Xác minh tham số không thành công",
  "503fd1718d": "Gửi mã xác minh SMS không thành công",
  "24b3129f19": "Gửi SMS quá thường xuyên, vui lòng thử lại sau",
  "1cde3e8245": "Mã xác minh không đúng, vui lòng nhập lại",
  "4212ecc031": "Đã xác minh sai nhiều lần, xác minh tạm thời bị hạn chế, vui lòng thử lại sau",
  "735da9c347": "Xác minh trùng tên doanh nghiệp gặp lỗi, vui lòng liên hệ bộ phận chăm sóc khách hàng chính thức để được giải quyết",
  "8731da9615": "Xác minh chứng thực tên doanh nghiệp gặp lỗi, vui lòng liên hệ bộ phận chăm sóc khách hàng chính thức để được giải quyết",
  "62e89b3f16": "Đồng ý thỏa thuận dịch vụ",
  "c9b79027e5": "Gửi mã xác minh",
  "84c1447b9d": "Sao chép thành công",
  "fba4b0abd0": "Bản ghi Host",
  "37f5a7cd41": "Giá trị TXT",
  "78b12427c9": "Đang xác thực...",
  "59d089837c": "Chúng tôi hiện không thể xác minh tên miền của bạn. Bạn có thể cần đợi thêm một thời gian để nhà cung cấp dịch vụ lưu trữ tên miền cập nhật thông tin của bạn. Nếu sau một thời gian vẫn không có phản hồi, vui lòng thử xác minh lại hoặc thay đổi tên miền.",
  "4a5b7383d1": "Đang kiểm tra tên miền",
  "f24a492e40": "bản ghi xác minh, bạn có thể đóng trang này và quay lại kiểm tra sau.",
  "c697ca5f1a": "Chào mừng bạn đến với phiên bản Doanh nghiệp",
  "ebb01b1740": "Tiếp theo",
  "30109bf753": "Doanh nghiệp của bạn có tên miền không?",
  "2b3e485b47": "Tôi có tên miền doanh nghiệp",
  "1a7f5eae44": "Tôi không có tên miền doanh nghiệp",
  "bde15d6d84": "Bạn cần có tên miền (ví dụ: example.com) để chúng tôi có thể tạo tài khoản doanh nghiệp cho bạn.",
  "07ffb22c90": "Rất tiếc, bạn cần có tên miền để tạo tài khoản doanh nghiệp cho doanh nghiệp của bạn.",
  "de23836563": "Vui lòng nhập tên miền dùng để tạo tài khoản doanh nghiệp",
  "287c07944a": "Xác minh tên miền của bạn",
  "3ea2d528d5": "Hoàn thành các bước sau để chứng minh bạn là chủ sở hữu của <b>{domain}</b> và ngăn chặn bất kỳ ai khác sử dụng tên miền này để đăng ký tài khoản doanh nghiệp.",
  "082b18ce56": "a. Mở trang web của nhà cung cấp dịch vụ lưu trữ tên miền trong <b>tab mới</b>, sau đó <b>đăng nhập</b> vào tài khoản của bạn;",
  "4f7e0841a9": "b. Trên trang web của nhà cung cấp dịch vụ lưu trữ tên miền, truy cập <b>phần Bản ghi DNS</b>. Trên trang web của nhà cung cấp dịch vụ lưu trữ tên miền của bạn, tên của phần bản ghi DNS có thể khác nhau, ví dụ: có thể hiển thị là <b>DNS Management (Quản lý DNS), Name Server Management (Quản lý Máy chủ Tên), Control Panel (Bảng điều khiển) hoặc Advanced Setting (Cài đặt nâng cao).</b>",
  "6365ad6e3a": "Tiếp theo, <b>quay lại đây</b>, sau đó nhấp vào Tiếp theo để thêm bản ghi xác minh.",
  "8528892080": "Thêm bản ghi xác minh",
  "7a225304f8": "a. Trên trang DNS, cuộn đến phần <b>TXT</b>, sau đó nhấp vào nút liên quan để thêm bản ghi;",
  "b3cb7d947c": "b. <b>Sao chép và dán</b> tất cả các giá trị bên dưới vào <b>biểu mẫu TXT</b> trên trang web của nhà cung cấp dịch vụ lưu trữ tên miền;",
  "47213583bf": "c. <b>Lưu</b> bản ghi trên trang web của nhà cung cấp dịch vụ lưu trữ tên miền,<br>sau đó <b>quay lại đây</b>, và nhấp vào Xác thực tên miền bên dưới",
  "21486a57cf": "Lưu ý: Trong trường Tên/Host/Bí danh, bạn có thể nhập \"@\" hoặc để trống. Nhà cung cấp dịch vụ lưu trữ tên miền cũng có thể yêu cầu bạn nhập tên miền (<Tên miền của bạn>.com) vào trường này. Bạn có thể dựa vào các bản ghi DNS khác để xác định cách điền trường này. Trong trường Thời gian tồn tại (TTL), hãy nhập \"86400\" hoặc giữ nguyên giá trị mặc định.",
  "f1b8edab9c": "Thay đổi tên miền",
  "7c6fc663a8": "Xác minh tên miền",
  "b6aee9dc0d": "Xác minh tên miền thành công",
  "dd4cc429ea": "Đã chứng minh bạn là",
  "450f5c9230": "chủ sở hữu của, và cấm bất kỳ ai khác sử dụng tên miền này để đăng ký tài khoản doanh nghiệp.",
  "71cbcba755": "Nhấp vào “Tiếp theo” để hoàn tất việc tạo tài khoản doanh nghiệp.",
  "f4084f4870": "Vui lòng thiết lập tài khoản đăng nhập của bạn",
  "fe3138baec": "Hoàn tất tạo",
  "0315cddedb": "Tạo doanh nghiệp thành công",
  "91454a7f34": "Bây giờ hãy đăng nhập vào trang quản trị để tạo tài khoản doanh nghiệp cho các thành viên của bạn.",
  "366304cde7": "1. Sẽ tự động đăng xuất khỏi tài khoản WPS hiện tại",
  "8a9f2a8422": "2. Bạn cần sử dụng tài khoản doanh nghiệp {account}@{domain} để đăng nhập vào trang quản trị.",
  "43e265e998": "Đăng nhập trang quản trị",
  "9240efaaf0": "Tin nhắn SMS đã được gửi",
  "e424bb9a6d": "Vui lòng nhập",
  "d44d581706": "Tên doanh nghiệp",
  "aa8679f406": ", 4~30 ký tự",
  "581bdb1f98": ", không được chứa các ký tự đặc biệt \\/:*?\"<>|{}",
  "c13cabb67a": "Email",
  "2b9b429e46": "Email của bạn",
  "5ed834a7df": "Vui lòng nhập email của bạn",
  "acfd1f02ed": "Vui lòng nhập email hợp lệ",
  "31c7c92cca": ", tối đa 80 ký tự",
  "3f27cf84b3": "Vui lòng nhập mã xác minh",
  "a0ae1f3ec4": "Mã xác minh không chính xác",
  "e5589c5e74": "Tên của bạn",
  "69d7bd63f6": ", chỉ được nhập chữ Hán, chữ cái, số",
  "91f008d258": ", tối đa 8 ký tự",
  "6ea6c9b39b": "Số điện thoại",
  "161042c5b7": "Vui lòng nhập số điện thoại",
  "e6b8eab1cd": "Vui lòng nhập số điện thoại, 11 chữ số",
  "3fd5fbb3cc": "Vui lòng nhập tên miền của bạn",
  "cb5346ba8e": "Vui lòng nhập đúng tên miền doanh nghiệp, 4~30 ký tự",
  "27928eb7a4": "Tài khoản",
  "8e19bd444d": "Vui lòng nhập tên tài khoản để đăng nhập",
  "7bbbf479dc": "4-20 ký tự, chỉ số, chữ cái hoặc gạch dưới",
  "3d84cae479": "Vui lòng nhập tài khoản đáp ứng yêu cầu/ký tự đầu tiên phải là chữ cái hoặc số",
  "c0d5ece1a7": "Mật khẩu",
  "f444036fa8": "Vui lòng nhập mật khẩu",
  "b03218d72b": "Mật khẩu phải có 12-16 ký tự, bao gồm chữ cái, số và ký hiệu.",
  "b4ab05df50": "*Đã có người trong đơn vị của bạn sử dụng tên miền của bạn cho tài khoản doanh nghiệp. Vui lòng liên hệ bộ phận chăm sóc khách hàng (400-677-5005) để chứng minh quyền sở hữu tên miền này của bạn.",
  "c58876008f": "Sao chép thất bại, vui lòng thử lại.",
  "86f73420de": "Liên kết mời",
  "a58861962c": "Xin lỗi, trình duyệt hiện tại của bạn không hỗ trợ tải xuống mã QR này.",
  "228db07f78": "Phòng Tài chính, Phòng Kinh doanh, Quản lý dự án, Dữ liệu kinh doanh, Phòng Sản phẩm, Phòng Vận hành, Quản lý R&D, Kế hoạch phiên bản, Phòng Dịch vụ khách hàng, Phòng Hành chính, Phòng Mua hàng, Quản lý hậu mãi",
  "93896d7e98": "Sau khi tạo nhóm, hãy bắt đầu cộng tác với đồng nghiệp.",
  "e8f66fb75c": "Phòng Tài chính, Phòng Kinh doanh, Quản lý dự án/305, Nhân sự Hành chính/306, Phòng Vận hành, Quản lý R&D, Kế hoạch phiên bản, Quản lý Dịch vụ khách hàng/403, Phòng Mua hàng, Quản lý hậu mãi",
  "831b73da9b": "Tên không được chứa ký tự không hợp lệ và ký hiệu đặc biệt /\\;:*?\"<>|%&",
  "51ab33b3ee": "Tham số không đúng",
  "a297f9e951": "Tên doanh nghiệp bị trùng lặp",
  "04d60ed5f5": "Không được sử dụng từ ngữ cấm",
  "2ff7bef083": "Định dạng tên miền không hợp lệ",
  "41e1ba2165": "Xác minh thông tin TXT tên miền thất bại",
  "50f348caa9": "Tài khoản đã tồn tại",
  "9d4c950d65": "Tên này đã được đăng ký sử dụng",
  "38cf19ed95": "Tên tổ chức này đã tồn tại",
  "4b426e7c9c": "Tên tổ chức",
  "298f880e18": "Đã tồn tại, bạn nên bổ sung thêm thông tin:",
  "1e67dd20b3": "Lấy lại tên tổ chức",
  "517107cb04": "Sử dụng tên khác",
  "5667081882": "Tạo bằng tên này",
  "e306a979a6": "Điền nhanh:",
  "f583db96e0": "*Nếu tên tổ chức đã được sử dụng, bạn có thể",
  "9767148e34": "Vui lòng nhập tên doanh nghiệp hoặc tổ chức, 4~100 ký tự",
  "e0e0ec159f": "Tên tổ chức",
  "5b13d254c0": "Tên doanh nghiệp này đã tồn tại",
  "92027671ec": "Tên doanh nghiệp",
  "36d482a7fb": "Lấy lại tên doanh nghiệp",
  "79058a7577": "*Nếu tên công ty đã được sử dụng, bạn có thể",
  "c96dd48dba": "Tên doanh nghiệp",
  "842efad336": "*Nếu bạn là nhân viên doanh nghiệp, vui lòng",
  "860f9bd77b": "Liên hệ bộ phận chăm sóc khách hàng",
  "5a7ed18daf": "Tham gia doanh nghiệp",
  "ab470e9ace": "Để lại thông tin liên hệ",
  "0a7e0e48a7": "Tên doanh nghiệp đăng ký tham gia:",
  "a8dc318dcc": "Vui lòng kiểm tra lại thông tin liên hệ bạn đã điền, bộ phận chăm sóc khách hàng của nền tảng sẽ gọi điện cho bạn sau.",
  "6ea1f4d7f5": "Gửi tài liệu",
  "d439e39f43": "Đã nhận được tài liệu của bạn.",
  "884653426b": "Bộ phận chăm sóc khách hàng sẽ gọi cho bạn trong vòng 24 giờ. Vui lòng chú ý nghe máy!",
  "2361cb14bf": "Quét mã QR WeChat để thêm dịch vụ chăm sóc khách hàng trực tuyến, tìm hiểu tiến độ.",
  "50f45d0031": "Lưu thất bại",
  "fc856d0fd2": "Quản trị viên cấp cao",
  "e16c0676d2": "Quản trị viên",
  "b1d2ddd126": "Thành viên thông thường",
  "9d322cc08d": "Tên tổ chức không được chứa các ký tự đặc biệt \\/:*?\"<>|{}",
  "b583ba7363": "Tên doanh nghiệp không được chứa các ký tự đặc biệt \\/:*?\"<>|{}",
  "1d118a9bad": "Tên tổ chức phải có ít nhất 4 ký tự, vui lòng nhập tên tổ chức từ 4 đến 100 ký tự.",
  "441b45b1f5": "Tên doanh nghiệp phải có ít nhất 4 ký tự, vui lòng nhập tên doanh nghiệp từ 4 đến 100 ký tự.",
  "97457cb1f0": "Tên tổ chức đã vượt quá 100 ký tự, vui lòng nhập tên tổ chức từ 4 đến 100 ký tự.",
  "8ce00d3b92": "Tên doanh nghiệp đã vượt quá 100 ký tự, vui lòng nhập tên doanh nghiệp từ 4 đến 100 ký tự.",
  "a72778d3de": "Tên phải có ít nhất 2 ký tự, vui lòng nhập tên từ 2 đến 10 ký tự.",
  "79c17db5de": "Tên đã vượt quá 10 ký tự, vui lòng nhập tên từ 2 đến 10 ký tự.",
  "482a118202": "Tên chỉ hỗ trợ ký tự tiếng Trung, số, tiếng Anh, ·",
  "9a9be18941": "Vui lòng chọn",
  "e6b7c4aa66": "Thỏa thuận dịch vụ trực tuyến",
  "595023d905": "Tạo tổ chức",
  "ba8c2df551": "Tạo doanh nghiệp",
  "d284384975": "Thỏa thuận dịch vụ trực tuyến",
  "5c266d5a84": "Chính sách quyền riêng tư",
  "fcb92dbcf6": "Thỏa thuận Dịch vụ Văn phòng Đám mây",
  "2ae7a8a3f7": "Cảm ơn bạn đã chọn Dịch vụ Văn phòng Đám mây WPS 365. Dưới đây chủ yếu giới thiệu các thỏa thuận pháp lý giữa bạn và/hoặc tổ chức bạn đại diện với Kingsoft Office về việc đăng ký, đăng ký thuê bao và sử dụng dịch vụ này.",
  "d30a6983bd": "Vui lòng đọc {0} | {1} | {2}, nhấp vào “Đồng ý” có nghĩa là bạn đồng ý với nội dung thỏa thuận và chấp nhận dịch vụ của chúng tôi.",
  "263e306ede": "Tôi đã đọc và đồng ý với {0} | {1} | {2}",
  "440129c0f1": "Vui lòng nhập {0}",
  "8ab916983d": "Tên tổ chức",
  "b01d68543b": "Tên của bạn",
  "684b30d4e9": "Số điện thoại di động của bạn",
  "a48427e8e2": "Dùng để thiết lập nền tảng làm việc riêng cho doanh nghiệp của bạn",
  "3a81b0f1fc": "Giúp đồng nghiệp dễ dàng tìm thấy bạn trong hệ thống để cộng tác làm việc",
  "52bc539b6e": "Xác nhận tạo",
  "b2fe245e19": "Tạo doanh nghiệp/nhóm: Chia sẻ và cộng tác tệp",
  "893282d3f7": "Vui lòng bổ sung thông tin doanh nghiệp:",
  "cc997bf6aa": "Xác nhận",
  "50fdde51ac": "{0}, {1}~{2} ký tự",
  "a19cc5ec18": "{0}, không được chứa các ký hiệu đặc biệt \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, chỉ được nhập chữ Hán, chữ cái, số",
  "f4080b1431": "{0}, tối đa {1} ký tự",
  "88e59b2d58": "{0}, 11 chữ số",
  "91d6d4e105": "Vui lòng nhập mã xác minh",
  "bec71bde96": "Mã xác minh không chính xác",
  "e20ff8ee19": "{0} là bắt buộc",
  "8dc09d10d7": "Không tìm thấy dwId",
  "a03766ce6c": "Trường học",
  "03542addfe": "Doanh nghiệp",
  "adb8a815d1": "Số điện thoại đã liên kết {0} đạt giới hạn.",
  "97a6b66f1d": "Số điện thoại hiện tại đã liên kết với {0}.",
  "665e465487": "Không thể tạo {0}, số lượng {0} đã liên kết với số điện thoại hiện tại “<strong>{1}</strong>” đã đạt giới hạn (tối đa có thể liên kết 5 {2}), bạn có thể vào {3} đã liên kết bên dưới:",
  "a85b1367ca": "Số điện thoại hiện tại “{0}” đã liên kết với {1}, bạn có thể chọn đăng nhập bằng {2} hiện có hoặc tạo {3} mới:",
  "bf992ce17b": "Tạo {0} bằng số điện thoại khác.",
  "395ea04444": "Tạo {0} mới.",
  "4ce3bb86b3": "Số lượng {0} tham gia đã vượt quá giới hạn.",
  "df88c4b7a5": "Số lượng {1} đã liên kết với số điện thoại hiện tại “{0}” đã đạt giới hạn.",
  "78f7dd59ca": "Số điện thoại hiện tại “{0}” đã liên kết với {1} sau, có thể chuyển đổi để sử dụng trực tiếp.",
  "8db491a3f8": "Tiếp tục tạo {0} mới.",
  "83f6d9e1e4": "Thử lại.",
  "1dc5f11612": "Hoặc.",
  "217d76f53e": "Phản hồi vấn đề.",
  "b69a6ea62a": "Vui lòng nhấn giữ chuột trái để cào ra hai tấm khiên.",
  "3a31f64800": "Chúc mừng bạn đã cào ra khiên thành công<br/>Tiếp tục thao tác tiếp theo nhé.",
  "6a81fcee96": "Đang tải.",
  "e97877a65d": "Ôi, khiên đã biến mất<br/>Vui lòng ",
  "8d85456145": "Tôi đã đợi quá lâu<br/>Vui lòng ",
  "77ad847b95": "Mạng quá yếu<br/>Vui lòng ",
  "dbd1ae3a34": "Bạn cào quá nhanh<br/>Vui lòng ",
  "bd8e05cd53": "Nhấp nút để bắt đầu xác minh thông minh.",
  "63d2a8a722": "Xác minh thành công.",
  "73141928ad": "Xác minh thất bại, vui lòng nhấp nút để làm mới.",
  "04856c5c8a": "Đang phát hiện thông minh.",
  "52cd9bd26d": "Thao tác của bạn chưa được ủy quyền.",
  "fd157e8ea8": "Tạo hướng dẫn",
  "c6225c5b2b": "Chào mừng bạn đến với phiên bản Doanh nghiệp",
  "e33423fb1e": "Tạo thành công",
  "7b0c035999": "Trang tạo tổ chức WPS Docs thành công",
  "85db8faae0": "Hướng dẫn sử dụng phiên bản Doanh nghiệp",
  "20591b9b44": "Khôi phục tên tổ chức",
  "b023d76dc2": "Hướng dẫn tải lên thành viên",
  "e2f454e095": "Tổ chức của {0}",
  "df466f942b": "Chi nhánh",
  "26a7b797c4": "Trung tâm con",
  "5fc82b360b": "Nền tảng dịch vụ văn phòng một cửa, giúp bạn làm việc hiệu quả hơn",
  "f2e736d52e": "Chào mừng bạn đến với phiên bản Doanh nghiệp",
  "becc41a35b": "Tên tổ chức",
  "74685cdc58": "Vui lòng nhập tên doanh nghiệp hoặc tổ chức, 4-100 ký tự",
  "07b55b1907": "Quy mô tổ chức",
  "77b2f763ad": "Vui lòng chọn quy mô tổ chức của bạn",
  "49d2509109": "Dưới 5 người",
  "8db2c9b74a": "6-20 người",
  "a9fb0cf14a": "21-50 người",
  "0fed41f8d3": "51-100 người",
  "fb33f25a04": "101-200 người",
  "3e3ff0f52e": "201-500 người",
  "cd8b51f634": "501-2000 người",
  "0662fa6eec": "Trên 2000 người",
  "69334dba1a": "Nhu cầu của doanh nghiệp",
  "79994e749c": "(Chúng tôi sẽ đề xuất các giải pháp thực tiễn tốt nhất trong ngành cho doanh nghiệp)",
  "840a017f38": "Vui lòng chọn vấn đề bạn muốn giải quyết nhất.",
  "f045b05c73": "Vui lòng nhập yêu cầu của bạn để tạo doanh nghiệp.",
  "d8efb0b36d": "Khác",
  "adcb8fbb0c": "Số điện thoại di động thường dùng",
  "eb1c73e2ca": "Vui lòng nhập số điện thoại di động 11 chữ số thường dùng của bạn.",
  "7f276e7dfa": "Tạo miễn phí",
  "c391b3eec1": "Gửi SMS thất bại",
  "54f4cb8fa7": "SMS đã được gửi",
  "231eb1fa1e": "Người dùng doanh nghiệp_{0}",
  "272b0f9d32": "Người dùng doanh nghiệp",
  "b209a67331": "Tạo doanh nghiệp thất bại, vui lòng làm mới trang.",
  "acb08d0cc9": "Bước ba tạo doanh nghiệp",
  "83db361f51": "Sau khi tạo xong, kích hoạt logic chuyển hướng.",
  "1e930326e3": "handleStep chuyển sang bước tiếp theo",
  "184df5c725": "saveForm thất bại",
  "736eab3023": "Gửi xác minh",
  "2db62dc13c": "Xác minh thất bại",
  "54fb0afaea": "Xác minh thành công",
  "d39cff3fcf": "Bỏ qua lưu trữ cực đoan chỉ để phát hiện cần mã xác minh.",
  "305b777ae5": "Kiểm tra tên thất bại, bật cửa sổ bật lên \"Tên doanh nghiệp đã được sử dụng\" và lưu trữ tên.",
  "e57b6686b2": "Kiểm tra xem chủ thể xác thực đã được xác thực chưa, bật cửa sổ bật lên thông báo bảo vệ xác thực & lưu trữ thông tin chủ thể xác thực tương ứng.",
  "f7c86f496d": "Tên tạo trùng lặp || Mã xác minh hết hạn. Nếu có bất kỳ trường hợp nào không đạt, sẽ ngăn chặn thực thi.",
  "cb37db4fd4": "handleSubmit thất bại",
  "243a569fc4": "Tên này đã được đăng ký, vui lòng sử dụng tên khác.",
  "196851a3d9": "Người dùng doanh nghiệp_{0}",
  "0c3a3595ff": "Người dùng doanh nghiệp",
  "a33b41e0f2": "Tạo doanh nghiệp thất bại, vui lòng làm mới trang.",
  "fcce6a7156": "Tạo thành công",
  "5ec6da58a6": "Thông báo cho máy khách",
  "259c9dfa4e": "Logic phiên bản chuyên nghiệp",
  "864156930f": "Logic VBA",
  "7824efd172": "WPS Docs di động",
  "52b6cfaaaf": "Máy khách WPS",
  "c7c51beea9": "Phiên bản giáo dục",
  "8d054d4986": "Máy khách mặc định",
  "b597e18fb1": "isWps365PcClient và có openurl",
  "b0c13de2a0": "isWps365PcClient hoặc không phải máy khách, có openurl",
  "7d0f2ce18c": "isWps365PcClient hoặc không phải máy khách, có callback openurl success",
  "e2c5a07df6": "Không phải máy khách, không openurl",
  "29e0414d1f": "Không phải máy khách, không openurl callback",
  "60861f7d2a": "autoChange được giao cho bên nghiệp vụ tự chuyển đổi",
  "7c83140d90": "Tạo ở trạng thái khách truy cập, không cần chuyển đổi tài khoản qua SDK (SDK không hỗ trợ khách truy cập), mã đã chuyển đổi thành công qua giao diện.",
  "3379b09e59": "Có openurl và sử dụng href để chuyển đổi",
  "586ff04c22": "Chuyển hướng riêng lẻ",
  "b6c91f218b": "useSuccessSkip thất bại",
  "47d2f3ba66": "Khác",
  "57551f86ce": "Kích hoạt các phương pháp chuyển hướng khác nhau dựa trên utm_source",
  "64fe3758e2": "Thao tác của bạn chưa được ủy quyền.",
  "4da3e1262f": "Tạo thành công, bắt đầu hành trình làm việc doanh nghiệp.",
  "c38dfb8c6c": "Tạo nhóm đầu tiên của bạn",
  "38dddb483b": "Vào tổ chức",
  "614d9c91eb": "Mời thành viên tham gia",
  "97f1eca0aa": "Vào tổ chức",
  "13a4939e90": "Tham gia lời mời tổ chức",
  "a319e4ae0a": "Mời đồng nghiệp tham gia",
  "12e4da6bba": "Mời đồng nghiệp ngay",
  "bd885380f6": "Lấy liên kết mời thất bại",
  "5e626c4063": "Tin nhắn đã gửi",
  "3dc09e7cfd": "Số lượng tên tổ chức bạn đã yêu cầu khôi phục đã đạt giới hạn",
  "48318f41f9": "Mời thành viên tham gia",
  "45441baac4": "Mời bạn tham gia {0} để cùng cộng tác",
  "e5847fbd67": "Sao chép liên kết, mời thành viên",
  "23101dd40a": "Đang tùy chỉnh giải pháp cho bạn",
  "71bb7e54a8": "Quản lý dự án",
  "aff37c79cc": "Trải nghiệm gói đã chọn",
  "a97b174258": "Mời thêm <color: red>2</> đồng nghiệp tham gia để nhận miễn phí các quyền lợi doanh nghiệp sau",
  "253855849f": "Chia sẻ liên kết mời đến nhóm làm việc để mời đồng nghiệp",
  "57b0a2a63f": "Sao chép liên kết, mời đồng nghiệp",
  "71c0a37ee1": "Vào tổ chức",
  "f848c60e0e": "Mời thêm <color:red>2</> đồng nghiệp tham gia để nhận miễn phí các quyền lợi doanh nghiệp sau",
  "664e32b4fe": "Trang mời: Vào tổ chức",
  "872f14403a": "Mời đồng nghiệp tham gia",
  "1880e7deb9": "Mời đồng nghiệp ngay",
  "cc2a9aaf82": "Tạo thành công",
  "02a13e2583": "Mời thêm <color: red>2</> đồng nghiệp tham gia để nhận miễn phí các quyền lợi doanh nghiệp sau",
  "5d3593cdce": "Không thể lấy thông tin nhóm",
  "c025113ea1": "Không thể lấy liên kết mời",
  "b83bc1e485": "Mời qua liên kết",
  "0996ced9f6": "Rất tiếc, trình duyệt hiện tại của bạn không hỗ trợ tải xuống mã QR này.",
  "1e88451e31": "Đã sao chép liên kết mời",
  "bb969cabcd": "Sao chép thất bại, vui lòng thử lại.",
  "15e1f79c7a": "Đăng ký tham gia doanh nghiệp",
  "59c22b4ef8": "Đã nhận được một liên kết mời",
  "0f0b392e60": "Tạo nhóm đầu tiên của bạn",
  "0437d07c43": "Tên doanh nghiệp",
  "41800c7bf1": "Vui lòng nhập tên người tạo",
  "1ec5999511": "Tên người tạo tối đa 8 ký tự",
  "02da35b4e4": "Tên người tạo chỉ được phép chứa ký tự tiếng Trung, chữ cái và số.",
  "184e9f6616": "Vui lòng nhập số điện thoại liên hệ",
  "9b587898ba": "Vui lòng nhập số điện thoại liên hệ đúng định dạng.",
  "e68c164a02": "Vui lòng nhập email của bạn",
  "0b1de22df7": "Vui lòng nhập email đúng định dạng.",
  "61026181ab": "Giấy phép kinh doanh là bắt buộc.",
  "c3847e604e": "Kích thước tệp vượt quá 10MB, vui lòng chọn lại.",
  "49450f4ec7": "Mẫu đơn khiếu nại trùng tên là bắt buộc.",
  "39c3b8fa1d": "Gửi thất bại.",
  "3ea44d7963": "Tải lên thành công.",
  "5b1aa3c2c4": "Tải lên thất bại.",
  "7e7f81eaa3": "Tải lên thất bại, tệp lớn hơn 10MB.",
  "2ff1913de1": "Tải lên thất bại, tệp phải là .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Giấy phép kinh doanh là bắt buộc",
  "66bda65057": "Kích thước tệp vượt quá 10M, vui lòng chọn lại",
  "8f2305a83d": "Biểu mẫu khiếu nại trùng tên là bắt buộc",
  "55ff0c8c6e": "Gửi thất bại",
  "8dad6d950d": "Không thể lấy thông tin lời mời",
  "a5f0ac3a9a": "Tạo thành công",
  "4f1d069770": "Các tham số utm của lượt truy cập trang lời mời là {0} và tên {1}",
  "f9578cfe6d": "Các tham số utm của truy cập hướng dẫn hai bước là {0} và tên {1}",
  "e10d028405": "Hướng dẫn hai bước pcoffice created",
  "8e22e4fcc4": "Đã sao chép liên kết lời mời",
  "3f327f9f37": "Sao chép thất bại, vui lòng thử lại",
  "bd1aecb265": "Hủy",
  "b6abf9b19a": "Đồng ý",
  "e910d9cc0f": "Hủy",
  "37ab25522d": "Đồng ý",
  "196b3eb9cf": "Quét mã để tham gia",
  "2b81c52e20": "Tải hình ảnh",
  "62152fd9f3": "Mời qua liên kết",
  "e0a3725651": "Xin lỗi, trình duyệt hiện tại của bạn không hỗ trợ tải xuống mã QR này",
  "8b7883b2c7": "Quét mã để tham gia",
  "9e9a659ed5": "Tải hình ảnh",
  "0d55065a9a": "Mời qua liên kết",
  "487cf6a106": "Xin lỗi, trình duyệt hiện tại của bạn không hỗ trợ tải xuống mã QR này",
  "78fd005d1f": "Vui lòng nhập số điện thoại",
  "f909563857": "Sử dụng số này để tạo",
  "a26a19f139": "Hủy tạo",
  "cc004ac9ee": "Số điện thoại",
  "4df8c3c588": "Nhập số điện thoại khác để tạo trường học",
  "3151cabb3d": "Nhập số điện thoại khác để tạo doanh nghiệp",
  "56098a71eb": "Nhấn xác minh thông minh để gửi mã xác minh",
  "e96ec218e4": "Vui lòng nhập mã xác minh SMS",
  "ce619a0225": "Mã xác minh SMS đã gửi đến",
  "0e9863aaeb": "Mã xác minh không đúng, vui lòng nhập lại",
  "32dc8629e1": "giây sau gửi lại",
  "e4eda9add5": "Gửi lại",
  "b007977564": "Lấy thông tin phê duyệt không thành công",
  "d8852ffc9c": "Truy cập không phải quản trị viên",
  "8a733a2574": "Truy cập trên thiết bị di động",
  "9e8c152c4f": "Truy cập trên PC",
  "2265a55e93": "Đồng ý thỏa thuận dịch vụ",
  "80dabe5aa3": "Tạo hướng dẫn",
  "7deee8bf5a": "Hướng dẫn hai bước docsWeb created",
  "69eb501ecb": "Khiếu nại của bạn đã hết hạn, không thể truy cập",
  "aa1d9d98ad": "Không đủ quyền, không thể truy cập",
  "fdf2fe129e": "Tạo tổ chức",
  "7f0ca0df6b": "Tạo doanh nghiệp",
  "cc6ac2a93c": "Hướng dẫn hai bước Base mounted",
  "5d6c570bf0": "Hướng dẫn hai bước beforeunload",
  "a4eb8a192d": "Các nhóm đang được mọi người tạo",
  "4912e16a9d": "Tên doanh nghiệp đã được khôi phục.",
  "41c4e87ef2": "Bạn có thể nhấp vào liên kết.",
  "5e630930c0": "Tạo lại doanh nghiệp",
  "436a563524": "Nếu bạn đã tạo doanh nghiệp, bạn có thể tham khảo",
  "0b6e7cbe7f": "“Cách sửa đổi tên doanh nghiệp”",
  "cb7bce0775": "hướng dẫn sửa đổi tên doanh nghiệp",
  "3feadd3040": "Phiên bản hiện tại quá cũ, không thể sử dụng doanh nghiệp.",
  "3cf23de936": "Phiên bản phần mềm của bạn quá cũ, không thể sử dụng tính năng doanh nghiệp. Vui lòng truy cập cửa hàng ứng dụng để cập nhật phiên bản phần mềm!",
  "a1c5d5d202": "Đã hiểu",
  "e50183bd00": "Tài liệu đám mây WPS",
  "e5031ab679": "Bảo mật, Đồng bộ, Cộng tác",
  "c870026dfc": "Đăng nhập bằng WeChat",
  "e7647cd875": "Số điện thoại hoặc email",
  "07b380074b": "Đăng nhập bằng QQ",
  "67921724dd": "Các phương thức khác",
  "254da8a9f5": "Số lượng doanh nghiệp tham gia/tạo đã đạt giới hạn tối đa.",
  "3648e4811b": "Vào WPS Docs",
  "dcd102b346": "Tạo nhóm tùy chỉnh",
  "8b9b258cbf": "Nhập tên nhóm tại đây",
  "19bb6e0ded": "Thành viên WPS được hưởng",
  "2d9fe8d938": "đặc quyền văn phòng, giúp bạn giải quyết các vấn đề tài liệu trong công việc hàng ngày, hãy trải nghiệm ngay!",
  "e8c1caa649": "Tải lên từ cục bộ",
  "03641083a3": "Di chuyển từ “Tài liệu cá nhân”",
  "eecd3ab9b5": "Để sau",
  "13b447b3a8": "Làm mới",
  "3c2fc507fc": "Phiên bản hiện tại quá thấp, không thể sử dụng tính năng doanh nghiệp",
  "c3615d8134": "Phiên bản phần mềm của bạn quá cũ, không thể sử dụng các tính năng doanh nghiệp. Vui lòng truy cập trang web chính thức để cập nhật phiên bản phần mềm!",
  "644a36e05b": "Cập nhật ngay",
  "d435105f21": "Số lượng doanh nghiệp đã tham gia/tạo đã đạt giới hạn tối đa",
  "73a286ceb0": "Truy cập WPS Docs",
  "c2cec645c0": "Hủy",
  "b5f5b83c0f": "Đồng ý",
  "76ec352da5": "Quét mã để mời đồng nghiệp",
  "6a509e4487": "Tải mã QR",
  "940cc4a546": "Không thể tạo doanh nghiệp",
  "78b2a62ea5": "Tham gia doanh nghiệp đã có hoặc tạo doanh nghiệp mới",
  "3a6da7f6f9": "Số điện thoại hiện tại đã liên kết đến số lượng doanh nghiệp tối đa (tối đa 5 doanh nghiệp).",
  "93bab52870": "Số điện thoại hiện tại đã liên kết với doanh nghiệp, bạn có thể chọn doanh nghiệp đã có để đăng nhập:",
  "ce6e0adaf2": "Bạn có thể chọn tham gia các doanh nghiệp đã liên kết dưới đây:",
  "1ce200a92b": "Chọn",
  "bb91ef2999": "Tạo doanh nghiệp mới",
  "024e4a91e5": "Tên doanh nghiệp đã được đăng ký sử dụng",
  "eb089a23a0": "Tên doanh nghiệp này đã được đăng ký sử dụng:",
  "7646558701": "Quản trị viên:",
  "1d9c02bd33": "Thời gian đăng ký:",
  "919fc7805f": "Chúng tôi khuyên bạn nên thử tìm và liên hệ với các đồng nghiệp đã đề cập ở trên.",
  "0ca71a9344": "Bạn cũng có thể tạm thời sử dụng tên khác để tạo doanh nghiệp (có thể thay đổi sau này), sau đó gửi yêu cầu khiếu nại.",
  "e83a244e90": "Nhấp để tìm hiểu cách khiếu nại.",
  "d22bedfb21": "Xác nhận",
  "907b78b6e5": "Nhập tên nhóm làm việc hoặc đội",
  "7195b0ac1e": "Các đội bạn có thể muốn tạo",
  "60ed4f915e": "Tiếp theo",
  "f5ba8dfb7b": "Bỏ qua hướng dẫn",
  "5c44a3ef68": "Tối đa 100 ký tự",
  "130c53fb20": "Tên không được chứa các ký tự không hợp lệ và ký hiệu đặc biệt /\\;:*?\"<>|%&",
  "e832d41acc": "Hướng dẫn hai bước – Bỏ qua",
  "80d9cf7177": "Hướng dẫn hai bước – Làm mới",
  "0aebf80435": "Hướng dẫn hai bước – Nhấp vào label",
  "e74f515977": "Hướng dẫn hai bước – handleSubmit",
  "308d2a53c9": "Hướng dẫn hai bước – createGroup",
  "dda2ed7e18": "Hướng dẫn hai bước – Tạo đội thất bại",
  "ded3c35500": "Tạo đội thất bại",
  "4f18031bc1": "Hướng dẫn hai bước – createTemplate",
  "091e5cefcc": "Hướng dẫn hai bước – Lỗi createTemplate",
  "58cf4e00f0": "Mã xác minh",
  "92abbf0385": "Gửi mã xác minh",
  "f0f9976ef9": "Vui lòng nhập số điện thoại",
  "a4ce99b1df": "Mã xác minh",
  "39d36e0f9f": "Xác nhận",
  "0fd8a01938": "Gửi",
  "9048a4e842": "Số điện thoại",
  "9afa1091eb": "Gửi lại",
  "58d787001f": "Nhập số điện thoại khác để tạo trường học",
  "450905a265": "Nhập số điện thoại khác để tạo doanh nghiệp",
  "f7386de3c6": "Lựa chọn thả xuống",
  "27aa05a92c": "Đồng ý điều khoản dịch vụ",
  "80af61cb57": "Quay lại trang trước",
  "50149b8d4f": "Họ và tên người đăng ký",
  "e6756f8749": "Vui lòng nhập họ và tên của bạn",
  "3cbd51a2b1": "Tên phải có ít nhất 2 ký tự. Vui lòng nhập tên từ 2 đến 10 ký tự.",
  "4f79b4813f": "Tên chỉ hỗ trợ ký tự tiếng Trung, số, tiếng Anh và ·",
  "71d3e75983": "Số điện thoại di động thường dùng",
  "afe5149035": "Vui lòng nhập số điện thoại di động thường dùng của bạn.",
  "1e9270b50f": "Vui lòng nhập số điện thoại di động thường dùng của bạn, gồm 11 chữ số.",
  "ff5dc98dfb": "Bỏ qua",
  "165be2ab43": "Quay lại bước trước",
  "231d8a335a": "Đồng ý điều khoản dịch vụ",
  "1cad008ffc": "Tên doanh nghiệp {0} đã được đăng ký, vui lòng sử dụng tên khác.",
  "c6e274fcab": "Xác nhận thỏa thuận",
  "b9352504bb": "Đóng cửa sổ bật lên thỏa thuận",
  "8409e99ad0": "Mở cửa sổ bật lên thỏa thuận",
  "1593c6dd95": "Gửi",
  "4f44a9de22": "Bật xác minh SMS",
  "26b70c68b8": "Bỏ qua và vào thẳng doanh nghiệp.",
  "a8bebcb302": "Quay lại trang trước",
  "c800b4fec5": "Trang mời Base Mounted",
  "38b396d5b0": "Trang mời docsWeb Mounted",
  "2eb7f9a9f1": "Khiếu nại của bạn đã được gửi thành công.",
  "2c6f3590fb": "Chúng tôi dự kiến sẽ gửi kết quả xử lý đến email của bạn trong vòng 3 ngày làm việc.",
  "2ea3eff708": ", vui lòng kiểm tra hộp thư đến.",
  "53acfba22c": "Mời đồng nghiệp ngay",
  "4e6d282f4f": "Tham gia lời mời doanh nghiệp",
  "5f72f4b936": "Mời đồng nghiệp ngay",
  "e5383077ba": "Khôi phục tên doanh nghiệp",
  "06e3fa2350": "Sau khi tra cứu,",
  "653a263b5e": "người tạo là",
  "769f57269f": "Số điện thoại di động của người tạo là",
  "09a224695e": "Vui lòng xác nhận người tạo doanh nghiệp này có phải là đồng nghiệp của bạn không.",
  "3beda6c149": "·Nếu là đồng nghiệp của bạn, bạn có thể liên hệ với người đó.",
  "5c74dd10d1": "Sửa đổi tên doanh nghiệp hoặc chuyển giao quản trị viên cấp cao.",
  "da504edb0f": "·Nếu không phải là đồng nghiệp của bạn, bạn có thể nhấp vào nút bên dưới để tiếp tục khôi phục tên doanh nghiệp.",
  "39194faaf1": "Tiếp tục khôi phục tên doanh nghiệp",
  "e22b829e90": "Sao chép thành công",
  "6e1b44752a": "Giá trị TXT",
  "79881b1d7a": "Mời đồng nghiệp ngay",
  "a5344a45f9": "Nhấp vào góc trên bên phải, chọn [Gửi cho bạn bè]",
  "a4954a5b08": "Mời đồng nghiệp ngay",
  "8e3a1625fb": "Khôi phục tên doanh nghiệp",
  "bf8b8c7005": "Tải lên giấy phép kinh doanh của doanh nghiệp",
  "bfd44a66c9": "Nhấp để chọn",
  "d503f20925": "Vui lòng tải lên bản quét hoặc ảnh giấy phép kinh doanh của doanh nghiệp",
  "cbebe043c5": "Hỗ trợ định dạng JPG, JPEG, PNG, BMP, PDF, kích thước không quá 10 MB.",
  "9650b96d7d": "Tải lên biểu mẫu thông tin khiếu nại trùng tên",
  "c3b8ae46d3": "Vui lòng tải lên bản quét hoặc ảnh biểu mẫu thông tin khiếu nại trùng tên",
  "9e325a9e09": "Tải xuống mẫu biểu mẫu thông tin",
  "a4711aae88": "Gửi yêu cầu",
  "3a5cc1441e": "Đang xác thực...",
  "0bd7bf8511": "Chúng tôi hiện không thể xác minh tên miền của bạn. Bạn có thể cần đợi thêm một thời gian để nhà cung cấp dịch vụ lưu trữ tên miền cập nhật thông tin của bạn. Nếu sau một thời gian vẫn không có phản hồi, vui lòng thử xác minh lại hoặc thay đổi tên miền.",
  "fae48d554b": "Đang kiểm tra tên miền",
  "5e1779a0ca": "...hồ sơ xác minh, bạn có thể đóng trang này và quay lại kiểm tra sau.",
  "ca85f8b836": "Chào mừng bạn đến với phiên bản Doanh nghiệp",
  "2570e0f00b": "Đăng nhập thất bại",
  "40d16a007e": "Tài khoản cá nhân của bạn đã được tự động liên kết.",
  "81376b92e4": "Phương thức đăng nhập của {0}, vui lòng đăng nhập lại để chuyển sang tài khoản doanh nghiệp.",
  "ba679ba739": "Đã hiểu, đi đăng nhập",
  "c05f64c6c6": "Tự động chuyển đến đăng nhập sau {0}",
  "c329ccef3a": "Đăng nhập thất bại",
  "e370f9afb1": "Đã tự động liên kết tài khoản cá nhân của bạn",
  "410cf42585": "phương thức đăng nhập, vui lòng đăng nhập lại để chuyển sang tài khoản doanh nghiệp.",
  "062d48aece": "Đã hiểu, đi đăng nhập",
  "95a105d412": "sau đó tự động chuyển đến đăng nhập",
  "2d000d5a6d": "Gửi liên kết chia sẻ cho thành viên, thành viên có thể đăng ký tham gia sau khi mở",
  "8861b6e90d": "Vào doanh nghiệp",
  "25b9f72fda": "Lỗi tham số trang",
  "1c76123efc": "Lấy liên kết mời thất bại",
  "6caba48b76": "Bỏ qua",
  "f66379c650": "Lỗi tham số trang",
  "c45021de2a": "Tạo thất bại",
  "011d470126": "Nền tảng liên tục bảo vệ an toàn thông tin của bạn",
  "f1a44d9151": "Nền tảng đã đạt được chứng nhận ISO27001, ISO27701 do BSI quốc tế cấp, và đã vượt qua đánh giá tiêu chuẩn an toàn bảo mật cấp 3 quốc gia--",
  "255ea5dff7": "Sách trắng bảo mật",
  "bb55b124f2": "Tạo hiển thị doanh nghiệp",
  "61e24974a3": "Tạo doanh nghiệp để truy cập nội dung chính sách",
  "bfdf78febe": "Bước tiếp theo hoàn thiện thông tin",
  "c4aa2d2d60": "Nhập tên nhóm làm việc hoặc dự án",
  "b69765ab64": "Các nhóm đang được mọi người tạo",
  "9657d9408b": "Làm mới",
  "e21da8c16a": "Tiếp theo",
  "224ef5cc9f": "Bỏ qua hướng dẫn",
  "641f58c8f6": "Tổ chức hiện tại không hỗ trợ thành viên tạo nhóm. Vui lòng liên hệ quản trị viên để tạo.",
  "efea622752": "Sao chép liên kết và mời đồng nghiệp",
  "fd5b40a9fd": "Mời bạn tham gia \"{0}\" để cùng cộng tác làm việc",
  "b04dd2f10a": "Đã sao chép liên kết mời",
  "d1606a1b1a": "Sao chép thất bại, vui lòng thử lại",
  "0d59f3db83": "Nhập phòng ban dự án hoặc nhóm, ví dụ \"Phòng Kinh doanh\"",
  "9429513d34": "Không cần hướng dẫn",
  "b54a20b1ff": "Tạo thất bại",
  "093fa0fb74": "Đang đăng nhập và ủy quyền...",
  "b383b136f4": "Khởi tạo dự án tổ chức",
  "b6b21b388b": "Tên tổ chức đã được đăng ký sử dụng",
  "285dc68c10": "Tên tổ chức này đã được đăng ký sử dụng:",
  "1bf685b89d": "Quản trị viên:",
  "7b4297edcc": "Thời gian đăng ký:",
  "fa51ea19fc": "Chúng tôi khuyên bạn nên thử tìm và liên hệ với các đồng nghiệp đã nêu trên.",
  "e3678a996d": "Bạn cũng có thể tạm thời sử dụng tên khác để tạo tổ chức (có thể thay đổi sau), sau đó gửi khiếu nại.",
  "5969bc8071": "OK",
  "ba4cf699df": "Khôi phục tên tổ chức",
  "afecee4eb4": "Tên của bạn",
  "a8bdebc614": "Vui lòng nhập tên của bạn",
  "5bbeb38a66": "Số điện thoại liên hệ",
  "b4f7b44b7a": "Vui lòng nhập số điện thoại liên hệ của bạn",
  "cac2913686": "Email liên hệ",
  "23d3bb3a42": "Vui lòng nhập email liên hệ của bạn",
  "ea106a393c": "Tải lên giấy phép kinh doanh của doanh nghiệp",
  "f74131d71e": "Nhấp để chọn",
  "53749c51c5": "Vui lòng tải lên bản quét hoặc ảnh chụp giấy phép kinh doanh của doanh nghiệp",
  "c00f2ea171": "Hỗ trợ định dạng JPG, JPEG, PNG, BMP, PDF, kích thước không quá 10 MB.",
  "57ec07fa97": "Tải lên biểu mẫu thông tin khiếu nại trùng tên",
  "8eb0606e94": "Vui lòng tải lên bản quét hoặc ảnh chụp biểu mẫu thông tin khiếu nại trùng tên",
  "f59e76c0b0": "Tải xuống mẫu biểu mẫu thông tin",
  "030bd26fa4": "Gửi đơn đăng ký",
  "0a602dc727": "Lưu trữ dữ liệu an toàn",
  "9138f28acf": "Chia sẻ và cộng tác tệp",
  "b3a306cf90": "Tuân thủ và hợp pháp hóa",
  "973c53f725": "Nên sửa đổi tên. Sau khi đăng ký, bạn có thể gửi yêu cầu xác thực tổ chức và cập nhật tên.",
  "f886f5e92f": "Nên sửa đổi tên. Sau khi đăng ký, bạn có thể gửi yêu cầu xác thực doanh nghiệp và cập nhật tên.",
  "b8051702a3": "Tên này chứa từ nhạy cảm, vui lòng điều chỉnh tên hoặc liên hệ nhân viên chăm sóc khách hàng.",
  "d73881f7d4": "Tên doanh nghiệp được bảo vệ",
  "dc7e58e320": "Tên doanh nghiệp được bảo vệ, cần xác minh thông tin chủ thể trước khi sử dụng. Nên sửa đổi tên doanh nghiệp, hoặc sử dụng tên này sau khi đăng ký và hoàn tất xác thực doanh nghiệp.",
  "20c3bc070c": "Xác nhận",
  "c4278e5f28": "Không đủ quyền",
  "9217efae21": "Tài khoản bạn đã đăng nhập tạm thời không có quyền tạo, vui lòng liên hệ nhân viên kinh doanh để được xử lý.",
  "52ff08f2ad": "Tên cơ quan được bảo vệ, vui lòng điều chỉnh tên doanh nghiệp.",
  "79386ae280": "Vui lòng nhập mã xác minh 6 chữ số",
  "d7b2c5a41b": "Mã xác minh đã được gửi đến",
  "ce2e1c26f7": "(Có hiệu lực trong 10 phút)",
  "59d338903f": "Có thể lấy lại mã xác minh sau {0} giây",
  "5aadd14136": "Lấy lại mã xác minh",
  "90f5c93432": "Tên này đã được đăng ký",
  "1677072f4a": "Bạn có thể bổ sung thêm thông tin hoặc đăng ký bằng tên khác.",
  "3b8459fb1e": "Điền nhanh:",
  "6f38edbcb1": "Đăng ký bằng tên này",
  "8406c81e2d": "Chi nhánh",
  "29d323fa85": "Trung tâm con",
  "4f0e806e02": "Phòng Tài chính",
  "3f935efb6b": "Đồng ý với điều khoản dịch vụ",
  "b42241be05": "Để sau",
  "99de4b33b7": "Đồng ý",
  "7f867e7395": "Tạo doanh nghiệp bằng số điện thoại khác",
  "0d51a8f7a6": "Tiếp tục tạo",
  "8bdaecf2e5": "Vui lòng nhập số điện thoại của bạn",
  "565ae60c8a": "Vui lòng nhập tên của bạn",
  "f76e06d0e7": "Vui lòng nhập số điện thoại của bạn",
  "7b0fca5255": "Vui lòng nhập mã xác minh",
  "68026d2d25": "Chào mừng bạn đến với phiên bản Doanh nghiệp",
  "d25b5541be": "Tạo miễn phí",
  "32cfd73733": "Vui lòng nhập tên nhóm, doanh nghiệp hoặc tổ chức của bạn",
  "4cf83dc4a0": "Tạo nhanh trong một phút, cộng tác hiệu quả với đồng nghiệp",
  "d320d37116": "Tạo nhóm/doanh nghiệp miễn phí",
  "c54b475dd2": "Thỏa thuận người dùng",
  "190d54e616": "Doanh nghiệp của {0}",
  "8c1b768ac4": "Xác minh thông minh thất bại",
  "d74eab0f35": "Thông tin tên doanh nghiệp bạn nhập không phù hợp với quy định của nền tảng, vui lòng sửa đổi và thử lại",
  "0f3d62dd4f": "Thông tin tên bạn nhập không tuân thủ quy định của nền tảng, vui lòng sửa đổi và thử lại.",
  "647cf2211b": "Không hỗ trợ tạo bằng số điện thoại hiện tại, vui lòng đổi số điện thoại khác.",
  "b63d96cdae": "Thông tin bạn nhập không tuân thủ quy định của nền tảng, vui lòng sửa đổi và thử lại.",
  "2dbbe8e43f": "Không hỗ trợ tạo bằng số điện thoại hiện tại, vui lòng sửa đổi và thử lại.",
  "b18abc5de6": "Chưa liên kết số điện thoại.",
  "f5233dae6f": "Vui lòng đổi số điện thoại khác để tạo.",
  "4167c8b88d": "Số điện thoại hiện tại có thể gặp các trường hợp sau, vui lòng thử đổi số điện thoại khác để tạo. Nếu có thắc mắc, vui lòng liên hệ bộ phận chăm sóc khách hàng để được tư vấn.",
  "a8a2433c4d": "Quét mã QR WeChat để thêm, liên hệ bộ phận chăm sóc khách hàng để được tư vấn.",
  "444a639c09": "Đã hiểu.",
  "69a097057f": "Số điện thoại hiện tại thuộc <#BB2726>dải số của nhà mạng ảo<#BB2726>.",
  "4370b06fd0": "Số điện thoại hiện tại có <#BB2726>hành vi sử dụng bất thường<#BB2726>.",
  "8c49e1dc4a": "Cần xác minh người máy.",
  "4b8ba7d8cc": "Nền tảng năng suất chất lượng mới cho văn phòng.",
  "81be771e17": "🎉Tạo doanh nghiệp thành công! Hoàn thiện thông tin để nhận dịch vụ độc quyền.",
  "461125b057": "Có thể quản lý tài liệu và dữ liệu trong nhóm. Thành viên nhóm có thể dễ dàng xem, đồng thời có thể thiết lập quyền chỉnh sửa/tải xuống, v.v. để đảm bảo an toàn dữ liệu.",
  "c3eb25029b": "Quy mô công ty/nhóm.",
  "049f8401ec": "Dưới 5 người.",
  "c81896349e": "6-20 người.",
  "7357daac4e": "21-50 người.",
  "f0e65a0a29": "51-100 người.",
  "b9fac8204a": "101-200 người.",
  "62d73dddaf": "201-500 người.",
  "3bcdaf7160": "501-2000 người.",
  "ab0b2333fe": "Trên 2000 người.",
  "4f756eedc8": "Vai trò của bạn là:",
  "3ba0b502c3": "Tổng Giám đốc",
  "702099cc72": "Tài chính",
  "843b603162": "Thu mua",
  "8b414a9b44": "Nhân sự/Hành chính",
  "92486b2908": "Kinh doanh",
  "ac4e7fb063": "Tổ chức của bạn có ngân sách/kế hoạch mua sắm phần mềm văn phòng không?",
  "37634c72dc": "Trong vòng 6 tháng",
  "bd94b6deec": "Trong vòng 1 năm",
  "713f4aad5c": "Đang xem xét",
  "c5ea095a4d": "Chưa có kế hoạch",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Tạo một nhóm, mời thành viên cùng cộng tác",
  "9d27dc2d90": "Có thể nhập tên nhóm của bạn hoặc các dự án được quan tâm gần đây.",
  "de19c8509a": "Bạn có thể muốn tạo:",
  "1a84699223": "Phòng Kinh doanh",
  "efab59502b": "Phòng Sản phẩm",
  "7e599b3713": "Phòng Vận hành Miền Nam",
  "bf494779c2": "Phòng Thu mua",
  "f3a60ab34d": "Phòng Hành chính",
  "bbc50c1ac8": "Phòng Tài chính Miền Bắc",
  "32629e3dac": "Phòng Tài chính Sản phẩm",
  "5524d354ba": "Phòng IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Bạn đã mở khóa quyền lợi người dùng mới!</span> Mời thêm 3 người để nhận <span style='color: rgb(206,131,62);'>4T dung lượng, WPS AI</span> quyền lợi",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Bạn đã mở khóa giới hạn 50 người, quyền lợi tải lên tệp đơn tối đa 4G</span>. Tiếp tục mời 3 người tham gia để mở khóa quyền lợi siêu giá trị 30 ngày WPS AI, 4T dung lượng",
  "136c26d941": "Sao chép liên kết bên dưới để mời thành viên tham gia.",
  "3de5c12558": "Sao chép liên kết, mời đồng nghiệp.",
  "a5d64b14f3": "Hướng dẫn thông tin doanh nghiệp",
  "b8f2492701": "Thu thập thông tin doanh nghiệp",
  "1f9d053dc0": "Tạo mẫu nhóm",
  "0e83c79a88": "Mời thành viên",
  "821fc1906a": "Vào tổ chức",
  "463e14ae9c": "Vui lòng chọn nhóm",
  "690f0cdb9e": "Biểu tượng hoàn thành",
  "c340522a17": "Quay lại",
  "f9355c72ef": "Bỏ qua",
  "bd6c09ebbb": "Tiếp theo",
  "2a2603cd3f": "Quét mã để gửi lời mời cho đồng nghiệp",
  "411e64907a": "Sao chép",
  "b0d988cf23": "Tải xuống",
  "e3c0b650ac": "Sao chép thành công",
  "713ac624b4": "Chào mừng bạn đến với WPS 365",
  "b8fff97849": "Phần tử mục tiêu không hợp lệ",
  "02acdcf296": "html2canvas chuyển đổi thất bại, chưa tạo được canvas",
  "a76988c496": "Chuyển đổi canvas thành blob thất bại",
  "af89584edf": "API bảng tạm không khả dụng",
  "f90263bbde": "Sao chép hình ảnh thất bại",
  "71b05319da": "Chuyển đổi html sang canvas thất bại",
  "38852999fe": "Lưu thông tin thất bại",
  "4a4c621d07": "Tạo nhóm thất bại, vui lòng thử lại sau",
  "d239a23994": "Trang này chỉ dành cho tài khoản doanh nghiệp, vui lòng đăng nhập tài khoản doanh nghiệp trước.",
  "d93bfb7fb9": "Vui lòng nhập nội dung",
  "42b81a66c4": "Độ dài từ 2 đến 100 ký tự",
  "76d33733db": "Không được chứa các ký tự đặc biệt như / \\ ; : * ? \" < > | % &",
  "dc55d1f62f": "Trải nghiệm ngay",
  "b25233cba0": "Cộng tác tài liệu + nhắn tin tức thời, mở ra phương thức làm việc hiệu quả mới.",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Bật trò chuyện nhóm cộng tác, chia sẻ tài liệu an toàn và tiện lợi.",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Trợ lý AI Lingxi, trợ lý thông minh dành riêng cho công việc văn phòng.",
  "e338385bc9": "Trợ lý thông minh Office gốc, tích hợp sâu AI và phần mềm văn phòng, giúp mọi người có trợ lý AI.",
  "7ae1f3b1c6": "Nhập tệp/thư mục hoàn tất, bạn có thể xem kết quả nhập trong “Tài liệu đám mây của tôi”.",
  "85db2a024a": "Nhập tệp/thư mục không thành công, vui lòng thử lại sau.",
  "9ff74c802a": "Tải xuống phiên bản chip Intel",
  "ab44928f02": "Tải xuống phiên bản chip Apple",
  "a08d937c38": "Đang tải lên tệp/thư mục, bạn có thể xem trong “Tài liệu đám mây của tôi” sau khi hoàn tất.",
  "68db1829fa": "Chỉ hỗ trợ nhập từ tài khoản cá nhân, vui lòng đăng nhập tài khoản cá nhân rồi thử lại.",
  "1185a7c7ab": "Dưới 20 người",
  "e2bcc252c9": "21-300 người",
  "3c4842f1ea": "301-1000 người",
  "1bbee64cfa": "Trên 1000 người",
  "388ff4a035": "Giáo viên",
  "d341b1d794": "Học sinh",
  "bfb2ee4148": "Khác",
  "f6450c3f31": "Quản lý dự án",
  "b87fd33a0d": "Kế hoạch hàng năm",
  "0dd45a1c14": "Quản lý hiệu suất nhân viên",
  "67fa01cac6": "Hoạt động marketing",
  "6dd82cc031": "Tuyển dụng nhân viên",
  "a7edaed91d": "Bài giảng điện tử",
  "bf12b7efb0": "Quản lý kế hoạch giảng dạy",
  "c35ae8f358": "Tài liệu sản phẩm",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Bảng tính đa chiều, xây dựng hệ thống kinh doanh chuyên biệt một cách trực quan",
  "72286d5519": "👏Mẫu gợi ý",
  "0bc00ee949": "Quản lý yêu cầu và lỗi",
  "e22f3d56f7": "Quản lý sáng tạo nội dung",
  "dd439de3dd": "Hệ thống quản lý khách hàng",
  "fbb2bbf82e": "Kế hoạch ôn thi",
  "0645b908bc": "Tra cứu bảng lương",
  "813b3d3d7e": "Quản lý OKR",
  "918e33d5bd": "Tạo nhanh",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Nhập tài liệu thường dùng, sử dụng tiện lợi hơn",
  "c58f28713c": "Nhập từ máy tính",
  "9d6a0a4370": "Hỗ trợ các định dạng tệp Office phổ biến",
  "54c48aee85": "Chọn tệp",
  "c5b593e452": "Nhập từ tài khoản cá nhân",
  "4bdcd9d4c5": "Nhập nhanh tài liệu tài khoản cá nhân, nhóm, thư mục",
  "99b2968905": "Ủy quyền nhập",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Tải xuống ứng dụng cộng tác WPS",
  "fe46574227": "Cộng tác tài liệu + nhắn tin tức thời, phương thức làm việc hiệu quả mới",
  "beefe5a09b": "Tải xuống ngay",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Cài đặt bảo mật phong phú, đảm bảo an toàn dữ liệu",
  "b4e70dbeab": "WPS với kinh nghiệm tích lũy nhiều năm về bảo mật tài liệu, đảm bảo dữ liệu quan trọng của doanh nghiệp không bị rò rỉ",
  "42dc772619": "Tệp quá lớn, vui lòng thử nhập lại trên trang chủ sau",
  "a052564e47": "Tạo thất bại, vui lòng thử lại sau",
  "790d0c428c": "Vào không gian làm việc"
}